(function (){
    'use strict';

    angular
        .module('services')
        .service('WebinarService', WebinarService);

    WebinarService.$inject = ['$http', 'API_BASE'];

    function WebinarService ($http, API_BASE) {
        var service = this;

        service.selectWebinars              = selectWebinars;
        service.getWebinarRequests          = getWebinarRequests;
        service.getWebinarRequestDetails    = getWebinarRequestDetails;
        service.destroy                     = destroy;
        service.hide                        = hide;
        service.show                        = show;
        service.approve                     = approve;
        service.disapprove                  = disapprove;
        service.update                      = update;
        service.getBlockedDates             = getBlockedDates;
        service.deleteBlockDate             = deleteBlockDate;
        service.getWebinarLocations         = getWebinarLocations;
        service.storeBlockDate              = storeBlockDate;
        service.deleteWebinar               = deleteWebinar;
        service.updateBlockDate             = updateBlockDate;
        service.deletePhoto                 = deletePhoto;
        service.uploadAttendeesFile              = uploadAttendeesFile;

        function selectWebinars()
        {
            return $http.get(API_BASE + '/webinar/selectWebinars')
                .then(function(response) {
                    return response.data;
                });
        }

        function getWebinarRequests(query)
        {
            return $http.get(API_BASE + '/webinar/getWebinarRequests',{params:query})
                .then(function(response) {
                    return response;
                });
        }

        function getWebinarRequestDetails(query)
        {
            return $http.get(API_BASE + '/webinar/getWebinarRequestDetails',{params:query})
                .then(function(response) {
                    return response;
                });
        }

        function destroy(id)
        {
            return $http.delete(API_BASE + '/webinar/' + id)
                .then(function(response) {
                    return response;
                });
        }

        function hide(id)
        {
            return $http.get(API_BASE + '/webinar/hide/' + id)
                .then(function(response) {
                    return response;
                });
        }

        function show(id)
        {
            return $http.get(API_BASE + '/webinar/show/' + id)
                .then(function(response) {
                    return response;
                });
        }

        function approve(id)
        {
            return $http.get(API_BASE + '/webinar/approve/' + id)
                .then(function(response) {
                    return response;
                });
        }
        function disapprove(id)
        {
            return $http.get(API_BASE + '/webinar/disapprove/' + id)
                .then(function(response) {
                    return response;
                });
        }

        function update(data)
        {
            return $http.post(API_BASE + '/webinar/update', data)
                .then(function(response) {
                    return response;
                });
        }

        function getBlockedDates()
        {
            return $http.get(API_BASE + '/webinar/blockdates')
                .then(function(response) {
                    return response;
                });
        }

        function getWebinarLocations()
        {
            return $http.get(API_BASE + '/webinar/locations')
                .then(function(response) {
                    return response;
                });
        }

        function deleteBlockDate(data)
        {
            return $http.post(API_BASE + '/webinar/blockdates/delete', data)
                .then(function(response) {
                    return response;
                });
        }

        function storeBlockDate(data)
        {
            return $http.post(API_BASE + '/webinar/blockdates/store', data)
                .then(function(response) {
                    return response;
                });
        }

        function deleteWebinar(data)
        {
            return $http.post(API_BASE + '/webinar/delete', data)
                .then(function(response) {
                    return response;
                });
        }

        function updateBlockDate(data)
        {
            return $http.post(API_BASE + '/webinar/blockdates/update', data)
                .then(function(response) {
                    return response;
                });
        }

        function deletePhoto(data)
        {
            return $http.post(API_BASE + '/webinar/deletePhoto', data)
                .then(function(response) {
                    return response;
                });
        }

        function uploadAttendeesFile(data)
        {
            return $http.post(API_BASE + '/webinar/attendeesfile', data)
                .then(function(response) {
                    return response;
                });
        }
    }
})();